import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Validators } from '@angular/forms';
import { MatFormField } from '@angular/material/form-field';
import { MatTooltip } from '@angular/material/tooltip';
import { ComponentDefinition } from '@formbird/types';
import { ChangedDocumentService } from 'formbird-services';
import { FormbirdInjectorService } from '@services/injector/formbird-injector.service';
import { RouterService } from '@services/router/router.service';
import { ComponentSetupService } from '../../../../formbird-sc-shared/src/lib/component-setup.service';
import { AbstractComponent } from '../../../../formbird-sc-shared/src/lib/components/abstract.component';

interface EmailComponentDefinition extends ComponentDefinition {
  caption?: string;
  onClick?: string;
  style?: string;
  subject?: any;
}

@Component({
  templateUrl: './email.component.html',
  styleUrls: ['./email.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmailComponent extends AbstractComponent<EmailComponentDefinition> implements OnInit {

  @Input() floatLabel: any;
  href = '';

  constructor(
    protected formbirdInjectorService: FormbirdInjectorService,
    protected changedDocumentService: ChangedDocumentService,
    protected componentSetupService: ComponentSetupService,
    protected cdr: ChangeDetectorRef,
    private routerService: RouterService
  ) {
    super(formbirdInjectorService, changedDocumentService, componentSetupService, cdr);
  }


  ngOnInit() {

    super.ngOnInit();

    if (this.fieldValue) {
      this.href = `mailto:${this.fieldValue}?Subject=${this.componentDefinition?.subject ?? ''}`
    }

  }

  setFieldActivation() {
    if (this.disabled) {
      this.formControl.disable({emitEvent: false});
    } else {
      this.formControl.enable({emitEvent: false});
    }
  }

  valueChanged(value) {
    this.changedDocumentService.valueChanged(this, value, this.registeredControlName);
    this.fieldValue = value;
    this.href = `mailto:${this.fieldValue}?Subject=${this.componentDefinition?.subject ?? ''}`
  }

  clickEmailEvent(event) {

    const hrefValue = 'mailto:' + this.document[this.fieldName] + '?Subject=' + this.componentDefinition.subject;
    if (event.shiftKey || event.ctrlKey) {
      this.routerService.navigateByUrl(hrefValue, '_blank');
    } else if (event.metaKey) {
      return;
    } else {
      event.stopPropagation();
      event.preventDefault();
      this.routerService.navigateByUrl(hrefValue);
    }
  }

  showToolTip(tooltip: MatTooltip, formFieldContainer: MatFormField, labelContainer: HTMLElement) {
    return (labelContainer.offsetWidth <= formFieldContainer._elementRef.nativeElement.scrollWidth);
  }

  toggleTooltip(tooltip: MatTooltip) {
    setTimeout(() => {
      tooltip.toggle();
    });
  }
}

